import { render, staticRenderFns } from "./pos-request-description.vue?vue&type=template&id=5701216b&scoped=true"
import script from "./pos-request-description.vue?vue&type=script&lang=js"
export * from "./pos-request-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5701216b",
  null
  
)

export default component.exports